import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

const SingleQuiz = ({ setQuizResult, options, index, id: quizId }) => {
    const [selectedOptions, setSelectedOptions] = useState([
        {
            id: 1,
            isSelected: false,
        },
        {
            id: 2,
            isSelected: false,
        },
        {
            id: 3,
            isSelected: false,
        },
        {
            id: 4,
            isSelected: false,
        },

    ])

    const handelChange = (e) => {
        const name = e.target.name;
        const stringId = name.split('-')[1]
        const optionId = parseInt(stringId)

        // change single quiz ans
        const newSelectedOptions = selectedOptions.map(single => {
            if (single.id === optionId) {
                return {
                    ...single,
                    isSelected: !single.isSelected
                }
            }
            return single
        })
        // check at Least one option has selected if false is Correct will undefined to know user doesn't select any option of this quiz
        const atLeastOneOptionSelected = newSelectedOptions.some((single) => single.isSelected === true);

        const areResultsEqualToMainAns = newSelectedOptions.every((single, index) => single.isSelected === options[index].isCorrect);

        // update Quiz result 
        setQuizResult(preQuizResult => {
            const newQuizResult = preQuizResult.map(single => {
                if (single.quiz_id === quizId) {
                    // if one has select then set value undefined 
                    return {
                        ...single,
                        isCorrect: atLeastOneOptionSelected ? areResultsEqualToMainAns : undefined,
                    }
                }
                return single
            })
            return newQuizResult

        })

        // update single quiz isCorrect values
        setSelectedOptions(newSelectedOptions)

    }
    return (
        <div className="quiz">
            <h4 className="question">Quiz {index} - What is a Debounce function in JavaScript?</h4>
            <form className="quizOptions" >
                {/* <!-- Option 1 --> */}
                {
                    options.map((single, optionIndex) => {
                        const domId = `option${index}_q${index + optionIndex}`;
                        const name = `quizOptionId-${single.id}`
                        const isSelected = selectedOptions[optionIndex].isSelected

                        return <label key={optionIndex} htmlFor={domId}>
                            <input onChange={handelChange} value={isSelected} type="checkbox" name={name} id={domId} />
                            {single.option}
                        </label>
                    })
                }

            </form>
        </div>

    );
};

export default SingleQuiz;